import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Card, CardContent } from './Card';
import { Carousel, CarouselContent, CarouselItem } from './Carousel';
import type { CarouselApi } from './Carousel';
export function Testimonials() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    const onSelect = () => setCurrent(api.selectedScrollSnap());
    api.on('select', onSelect);
    return () => {
      api.off('select', onSelect);
    };
  }, [api]);
  useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 4000);
    return () => clearInterval(interval);
  }, [api]);
  const reviews = [{
    text: 'Rigo and his crew showed up on time, cleaned everything up, and charged a fair price. Highly recommend.',
    author: 'Maria G.'
  }, {
    text: 'We had a tree dangerously close to our roof after a storm. Phoenix Tree Experts came out the next day and took care of it fast.',
    author: 'James T.'
  }, {
    text: 'Professional, bilingual, and honest. Best tree service in the Valley.',
    author: 'Linda R.'
  }];
  return <section id="reviews" className="w-full bg-brand-bg py-16 md:py-24" data-id="element-122">
      <div className="container mx-auto px-6" data-id="element-123">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-display text-3xl md:text-5xl text-white text-center mb-12 md:mb-16" data-id="element-124">
          What Our Clients Say
        </motion.h2>

        <div className="hidden md:grid md:grid-cols-3 gap-6" data-id="element-125">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-126">
              <Card className="bg-zinc-900 border-zinc-800 h-full" data-id="element-127">
                <CardContent className="p-6" data-id="element-128">
                  <div className="flex gap-1 mb-4" data-id="element-129">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-green text-brand-green" data-id="element-130" />)}
                  </div>
                  <p className="font-body text-white/90 mb-4 leading-relaxed" data-id="element-131">
                    "{review.text}"
                  </p>
                  <p className="font-body text-brand-green font-semibold" data-id="element-132">
                    {review.author}
                  </p>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>

        <div className="md:hidden" data-id="element-133">
          <Carousel setApi={setApi} opts={{
          loop: true
        }} data-id="element-134">
            <CarouselContent data-id="element-135">
              {reviews.map((review, index) => <CarouselItem key={index} data-id="element-136">
                  <Card className="bg-zinc-900 border-zinc-800" data-id="element-137">
                    <CardContent className="p-6" data-id="element-138">
                      <div className="flex gap-1 mb-4" data-id="element-139">
                        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-green text-brand-green" data-id="element-140" />)}
                      </div>
                      <p className="font-body text-white/90 mb-4 leading-relaxed" data-id="element-141">
                        "{review.text}"
                      </p>
                      <p className="font-body text-brand-green font-semibold" data-id="element-142">
                        {review.author}
                      </p>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>
          <div className="flex justify-center gap-2 mt-6" data-id="element-143">
            {Array.from({
            length: count
          }).map((_, index) => <button key={index} type="button" aria-label={`Go to review ${index + 1}`} onClick={() => api?.scrollTo(index)} className={`h-2.5 rounded-full transition-all ${current === index ? 'w-6 bg-brand-green' : 'w-2.5 bg-white/30'}`} data-id="element-144" />)}
          </div>
        </div>
      </div>
    </section>;
}